import Base from "../Base";

export default class Taxes extends Base {
  tax(){
    return this._api.post("/tax/");
  }
}